var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app-bar-header"}},[_c('Logo'),_c('p',{style:({ color: _vm.myColors.foreground }),attrs:{"id":"header-title"}},[_vm._v(_vm._s(_vm.myName))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }